import { Navigate } from 'react-router-dom';

// Clipper ST433 "Stickers de Recepción de Carga" is the per-bulto label emission screen in V3.
export default function StickersDeRecepcionDeCarga() {
  return <Navigate to="/cargas/etiquetas/nueva" replace />;
}
